// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3IK_X","rootCenter":"LoadMoreObserver_rootCenter__3z5ga","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2nfwt"};